export type ChipPosition = {
  right: number;
  bottom: number;
  '--degrees': string;
}

export const getRadialPositions = (
  count: number,
  size: number,
  vertical: boolean,
  radiusScale = 1
): ChipPosition[] => {
  if (count <= 0) {
    return []; // Return an empty array if count is zero or negative
  }

  if (count === 1) {
    // Special case for 1 chip, position at the center
    return [ {
      right: 0,
      bottom: 0,
      '--degrees': '0deg',
    } ];
  }

  const step = Math.PI / (count - 1);
  const radius = size * (count / 2) * radiusScale;

  return [ ...Array(count).keys() ].map((index) => {
    const angle = index * step - (vertical ? Math.PI / 2 : 0);
    return {
      right: (radius - size) * Math.cos(angle),
      bottom: (radius - size) * Math.sin(angle),
      '--degrees': `${angle * (180 / Math.PI)}deg`,
    };
  });
};
